import { Modal } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { ResponsesCoeMarketStatusResponse } from '@genial/services/dist/models';
import { useBreakpointValue } from '@genial/utils';
import { Modal as NBModal, ScrollView } from 'native-base';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { useRecoilQuery } from '../../../../hooks/useRecoilQuery';
import {
  structuredOperationProductSelectedState,
  structuredOperationsMarketStatusState,
} from '../../../../store/product/atom';
import { structuredOperationDetailsQuery } from '../../../../store/product/selectors';
import { CoesOfferEntityNormalized } from '../../../../store/product/types';

import { StructuredOperationContentDetails } from './components/StructuredOperationContentDetails';
import { StructuredOperationDetailsError } from './components/StructuredOperationDetailsError';
import { StructuredOperationDetailsLoading } from './components/StructuredOperationDetailsLoading';

interface StructuredOperationDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  offer?: CoesOfferEntityNormalized;
  marketStatus?: ResponsesCoeMarketStatusResponse;
}

export const StructuredOperationDetailsModal: React.FC<StructuredOperationDetailsModalProps> = ({
  isOpen,
  onClose,
  marketStatus,
  offer,
}) => {
  const isDesktop = useBreakpointValue({ base: false, lg: true });
  const productSelected = useRecoilValue(structuredOperationProductSelectedState);

  const productItem = offer || productSelected;

  const structuredOperationsMarketStatus = useRecoilValue(structuredOperationsMarketStatusState);
  const marketStatusItem = marketStatus || structuredOperationsMarketStatus;

  const {
    data: response,
    error,
    loading,
  } = useRecoilQuery(
    structuredOperationDetailsQuery({
      productId: productItem?.productId || '',
      callEndpoint: !!(productItem?.productId && productItem?.productId?.length > 0),
    }),
    {
      cachePolicy: 'no-cache',
    }
  );

  const structuredOperationsMarketIsClosed = marketStatusItem && marketStatusItem?.isOpened;

  const structuredOperationsMarketStatusMessage =
    (marketStatusItem && marketStatusItem?.message) || '';

  const marketStatusDetail = {
    isOpened: structuredOperationsMarketIsClosed,
    message: structuredOperationsMarketStatusMessage,
  };

  const StructuredOperationContent = (
    <ScrollView showsVerticalScrollIndicator={false} py={{ base: 0, lg: Spacing['stack.xxl'] }}>
      {loading && <StructuredOperationDetailsLoading />}
      {!loading && error && <StructuredOperationDetailsError onClose={onClose} />}
      {response && Object.keys(response?.data).length > 0 && !loading && !error && (
        <StructuredOperationContentDetails
          marketStatus={marketStatusDetail}
          strategy={productItem.strategy || ''}
          onClose={onClose}
          data={response?.data}
        />
      )}
    </ScrollView>
  );

  const modalContentDesktopProps = {
    maxH: 'full',
    alignItems: 'center',
    size: 'full',
    bg: 'transparent',
  };

  const modalContentMobileProps = {
    w: 'full',
    marginBottom: 0,
    marginTop: 'auto',
  };

  const modalCotentProps = isDesktop ? modalContentDesktopProps : modalContentMobileProps;

  return (
    <Modal testId="modal-structured-operation-content-details" isOpen={isOpen} onClose={onClose}>
      <NBModal.Content maxW={'full'} {...modalCotentProps}>
        {StructuredOperationContent}
      </NBModal.Content>
    </Modal>
  );
};
